import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { defaultComponentDefinitions } from '../component-definitions.js';
import { initialValue, BrConfigurationContext } from './configuration.js';

function BrConfigurationProvider({ settings , children  }) {
    const { apiUrl , customComponentMap , componentDefinitions =defaultComponentDefinitions ,  } = settings;
    const value = React.useMemo(()=>swcHelpers.objectSpread({}, initialValue, {
            apiUrl,
            componentDefinitions,
            customComponentMap
        })
    , [
        apiUrl,
        componentDefinitions,
        customComponentMap
    ]);
    return /*#__PURE__*/ React.createElement(BrConfigurationContext.Provider, {
        value: value,
        children: children
    });
}

export { BrConfigurationProvider };
//# sourceMappingURL=provider.js.map
